import { render } from "./ActiveCallDialog.vue?vue&type=template&id=b709c11e&scoped=true"
import script from "./ActiveCallDialog.vue?vue&type=script&lang=js"
export * from "./ActiveCallDialog.vue?vue&type=script&lang=js"

import "./ActiveCallDialog.vue?vue&type=style&index=0&id=b709c11e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b709c11e"]])

export default __exports__